export default "__VITE_ASSET__0f904992__"